import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClientRequestService } from 'src/app/http-client-request.service';
import { ConstantsService } from 'src/app/constants.service';


const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const numberPattern: RegExp = /^[0-9]*$/;
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  @Output() submitSuccess = new EventEmitter<void>();
  thankYouDiv: boolean = true;
  signUpFormHeader: boolean = false;
  signUpForm: boolean = false;
  checkboxSelection: boolean = false;
  disableButton: boolean = false;
  inputTokenBody: any;
  pharmacodeToken: String;
  recaptchabody: any;
  tokenResponse: String = null;

  constructor(private _formBuilder: UntypedFormBuilder, private _httpClientRequestService: HttpClientRequestService,
    private _constantsService: ConstantsService) { }

  signupForm: UntypedFormGroup;

  ngOnInit() {
    this.signupForm = this._formBuilder.group({
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      Email: ['', [Validators.required, Validators.pattern(emailPattern)]],
      Zip: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(numberPattern)]],
      AgeConsent: ['', Validators.requiredTrue],
      InquirerType: ['', Validators.required],
      TreatmentType: ['', Validators.required]     
    });
  }

  checkSelection(event) {
    this.checkboxSelection = event.target.checked;
  }

  // signup(){
  //   if(this.signupForm.valid){
  //     this.disableButton =  true;        
  //     this._httpClientRequestService.Post(this._constantsService.apiURL,this.signupForm.value).subscribe(Response =>{ 

  //       if(Response[0].Result == 'SUCCESS'){
  //         this.thankYouDiv = !this.thankYouDiv;
  //         this.signUpFormHeader = !this.signUpFormHeader;
  //         this.signUpForm = !this.signUpForm;

  //         this._constantsService.setValue(true);
  //         this.submitSuccess.emit();          
  //       }  
  //       else
  //         this.disableButton = false;     
  //     }); 

  //   }
  //   else
  //   this.signupForm.markAllAsTouched();

  // }

  signup() {

    if (this.signupForm.valid) {    
      // Removed captcha
      this.disableButton = true;
      this.inputTokenBody = {
        "ClientId": this._constantsService.apiPharmacodeClientId,
        "ClientSecret": this._constantsService.apiPharmacodeClientSecret,
        "Audience": this._constantsService.apiPharmacodeAudience,
        "GrantType": this._constantsService.apiPharmacodeGrantType
      }
            this._httpClientRequestService.Post(this._constantsService.apiPharmacodeToken, this.inputTokenBody).subscribe(Response => {
              this.pharmacodeToken = Response.Payload.access_token;
              this._httpClientRequestService.tokenValue = this.pharmacodeToken;

              if (this.pharmacodeToken != null) {
                this._httpClientRequestService.PostPharmacode(this._constantsService.apiPharmacodeRegisterProfile, this.signupForm.value).subscribe(Response => {
                  if (Response.Status == 'SUCCESS') {
                    this.thankYouDiv = !this.thankYouDiv;
                    this.signUpFormHeader = !this.signUpFormHeader;
                    this.signUpForm = !this.signUpForm;

                    this._constantsService.setValue(true);
                    this.submitSuccess.emit();
                  }
                  else
                    this.disableButton = false;
                });
              }
            });
    }
    else {
      this.signupForm.markAllAsTouched();
    }
  
  }


}